import Routes from 'constants/Routes';
import useGlobalSettings from 'hooks/useGlobalSettings';
import useHasAccessToRiddermarkReporting from 'hooks/useHasAccessToRiddermarkReporting';
import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Skyddar SIDAN /ledningsrapport, inte bara menyvalet.
 *
 * Att dölja menyposten räcker inte: rutten renderas utan villkor, så den som skriver in adressen
 * får vyn. Servern har den bindande spärren (KPIController och ExportController). Den här
 * komponenten finns för att användaren ska mötas av 404 i stället för en sida där varje anrop
 * svarar 403 och panelerna står tomma utan att säga varför.
 *
 * /nyckeltal-riddermark skyddas INTE av den här. Den vyn bär fyra widgetar som inte har med
 * ledningsrapporten att göra och som rollen RiddermarkLedning ensam räcker för; det är
 * rapportens sju widgetar inne i vyn som flaggan tar bort ur widgetlistan.
 */
const RequireRiddermarkReportingAccess: React.FC<{
  children: React.ReactElement;
}> = ({ children }) => {
  const hasAccess = useHasAccessToRiddermarkReporting();
  const { loaded, isError } = useGlobalSettings();

  // Vänta in inställningarna. Utan det här omdirigeras den som HAR tillgång, eftersom hooken
  // svarar false tills svaret kommit.
  //
  // isError måste prövas separat: `loaded` är isSuccess, som aldrig blir true efter ett fel. Utan
  // den grenen blir sidan permanent tom vid ett trasigt inställningsanrop — vit skärm, ingen text,
  // ingen omdirigering. Ett fel behandlas som "ingen tillgång": hellre fel sida än ingen sida.
  if (!loaded) {
    return isError ? <Navigate replace to={Routes.notFound} /> : null;
  }

  if (!hasAccess) {
    return <Navigate replace to={Routes.notFound} />;
  }

  return children;
};

export default RequireRiddermarkReportingAccess;
